<template>
    <div class="tab-content">
      <el-tabs activeName="first">
        <el-tab-pane :label="$t('bu_tab_comments_first')" name="first">
          <el-card>
            <div class="add-comment-btn">
                <el-button :disabled="!businessUnitPermission.postComments" @click="addComment" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('bu_tab_comments_first_btn_postComment')}}</el-button>
            </div>
            <!--{{businessUnitComments}}-->
            <div class="my-window">
                <!--<el-card v-for="item in businessUnitComments" :key="item" class="box-card">-->
                <!--<div slot="header" class="clearfix">-->
                <!--<span>{{moment(item.createDate.toString(), 'X').format('DD MMMM YYYY')}}</span>-->
                <!--<el-button style="float: right; padding: 3px 0" type="text">{{item.companyUser.user.fullName}}</el-button>-->
                <!--</div>-->
                <!--<div class="text item" v-html="item.text">-->
                <!--</div>-->
                <!--</el-card>-->
                <el-timeline v-if="businessUnitComments.length" style="padding-top: 20px;">
                    <el-timeline-item
                            v-for="item in businessUnitComments"
                            :key="item.id"
                            :timestamp="moment(item.createDate.toString(), 'X').format('LLLL')"
                            placement="top">
                        <div :id="item.id">
                            <el-card class="card">
                                <div slot="header" class="card__header">
                                    <div class="card__status">
                                        <div class="photo-group" v-if="item.companyUser.user">
                                            <img v-if="item.companyUser.user.avatarUrl" :src="item.companyUser.user.avatarUrl">
                                        </div>
                                        <el-tag size="small" type="success" style="margin-right: 10px;" v-html="item.companyUser.user.fullName"></el-tag>
                                    </div>
                                </div>
                                <div class="text item">
                                    <div class="notifications">
                                        <div class="notifications_box">
                                            <div v-if="item.clientNotificated" class="notifications_clients">{{$t('bu_tab_comments_first_notifyClients')}}: <i class="el-icon-success" style="color: green;"></i></div>
                                            <div v-if="item.vendorNotificated" class="notifications_vendors">{{$t('bu_tab_comments_first_notifyVendors')}}: <i class="el-icon-success" style="color: green;"></i></div>
                                        </div>
                                    </div>
                                    <div>
                                        <p style="margin: 0;"><strong>{{$t('bu_tab_comments_first_notes')}}:</strong></p>
                                        <div v-html="item.text" class="info-progress"></div>
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </el-timeline-item>
                </el-timeline>
            </div>
            <sweet-modal blocking :title="$t('modal_postComment')" ref="addComment" class="modal" v-on:close="closeModal">
                <el-form label-position="top" label-width="0" :model="form" status-icon ref="form" class="demo-ruleForm">
                    <el-form-item>
                        <vue2-custom-editor
                            ref="editor"
                            v-model="form.text">
                        </vue2-custom-editor>
                    </el-form-item>

                    <div class="flex-twocolumn">
                      <el-form-item>
                          <el-switch v-model="form.notifyBusinessUnitTeam"></el-switch> {{$t('modal_notifyTeams')}}
                      </el-form-item>
                      <!-- <el-form-item>
                          <el-switch v-model="form.notifyTaskTeam"></el-switch> {{$t('modal_notifyTaskTeam')}}
                      </el-form-item> -->
                      <el-form-item>
                          <el-switch :disabled="!businessUnitPermission.notifyClientsComments" v-model="form.notifyClients"></el-switch> {{$t('modal_notifyClients')}}
                      </el-form-item>
                      <el-form-item>
                          <el-switch :disabled="!businessUnitPermission.notifyVendorsComments" v-model="form.notifyVendors"></el-switch> {{$t('modal_notifyVendors')}}
                      </el-form-item>
                    </div>

                    <el-form-item class="modal__btn">
                      <el-button @click="modalCancel('addComment')">{{$t('general_cancel')}}</el-button>
                      <el-button @click="addCommentSubmit" type="primary">{{$t('general_submit')}}</el-button>
                    </el-form-item>
                </el-form>
            </sweet-modal>
          </el-card>
        </el-tab-pane>
      </el-tabs>
<!--        <div class="book-mark-block pointer">-->
<!--          <div>-->
<!--            <div v-if="bookmarkListBusinessUnit.comments" @click="changeBookMarkBusinessUnit(bookmarkListBusinessUnit.comments, $route.query.companyId, selectedRow.businessUnitId)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--            <div v-else @click="changeBookMarkBusinessUnit(bookmarkListBusinessUnit.comments, $route.query.companyId, selectedRow.businessUnitId)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--          </div>-->
<!--        </div>-->
    </div>
</template>

<script>
  let moment = require('moment')
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import Vue2CustomEditor from "../vue-2-custom-editor";
  import axios from 'axios'
  export default  {
    name: 'businessUnit-comments-tab',
    created() {

    },
    beforeMount() {
      // this.checkRow();
    },
    mounted(){

    },
    props: ['bookmarkListBusinessUnit', 'selectedRow', 'businessUnitPermission'],
    computed:{
      businessUnitComments(){
        return this.$store.state.businessUnitComments
      }
    },
    components:{
      SweetModal,
      Vue2CustomEditor,
    },
    data() {
      return {
        form:{
          text:'',
          notifyBusinessUnitTeam: true,
          notifyTaskTeam: false,
          notifyClients: false,
          notifyVendors: false
        },
        activeStar: 'el-icon-star-on',
        notActiveStar: 'el-icon-star-off',
        moment:moment,
      }
    },
    methods:{
      async selectActiveCommentNode(stateId){
        try {
          const childNode = await new Promise((resolve) => resolve(document.getElementById(stateId.toString())));

          if (childNode) {
            const parentContainer = await new Promise((resolve) => resolve(document.getElementById("pane-businessUnitCommentTab").parentNode));
            // get distance between blocks
            const distance = await this.countDistance(parentContainer.getBoundingClientRect(), childNode.getBoundingClientRect(), childNode.offsetTop, parentContainer.scrollTop);
            // console.log('distance', distance);
            parentContainer.scroll({
              top: distance,
              behavior: 'smooth'
            });
            // set active class to block
            await new Promise((resolve) => resolve(childNode.classList.add('hovered-node')));
            this.$store.dispatch('setStateId', null);
            setTimeout(() => {
              childNode.classList.remove('hovered-node');
            }, 5000)
          }
        } catch (err){
          console.log(err)
        }
      },
      countDistance(parent, child, childOffsetTop, parentScrollTop){
        // console.log('childOffsetTop', childOffsetTop);
        // console.log('parent-top', parent);
        // console.log('child-top', child);
        return new Promise ((resolve) => {
          let distance = 0;
          if (parent.top < child.top){
            distance = (child.top +  parentScrollTop) - parent.top - childOffsetTop;
          } else if (parent.top > child.top) {
            distance = parentScrollTop - (parent.top - child.top + childOffsetTop)
          }
          resolve(distance || 0)
        })
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      addComment(){
        this.$refs.addComment.open();
      },
      addCommentSubmit(){
        // alert('ADD Comment Submit')
        let data = {
          text: this.form.text,
          notifyBusinessUnitTeam: this.form.notifyBusinessUnitTeam,
          // notifyTaskTeam: this.form.notifyTaskTeam,
          notifyClients: this.form.notifyClients,
          notifyVendors: this.form.notifyVendors,
        }
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnitComments/create?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}`, data)
          .then(response => {
            console.log('---', response.data);
            if (response.data.success){
              console.log("SUCCESS")
              this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_addComment'), "success");
              loader.hide()
              this.$store.dispatch('getBusinessUnitComments')
              if (this.$refs.editor.uploadedImagesArray.length) {
                this.$store.dispatch('approveUploadedImages', {
                  fileUrlArr: this.$refs.editor.uploadedImagesArray,
                  entityId: response.data.businessUnitCommentId,
                  entityTypeId: 18 // bu comment
                })
              }
              this.$refs.addComment.close();
              this.form.text = '';
              this.form.notifyBusinessUnitTeam = true;
              this.form.notifyTaskTeam = false;
              this.form.notifyClients = false;
              this.form.notifyVendors = false;
            }
            loader.hide()
            // this.getProjects();
          })
          .catch(error => {
            this.notification("Notification", error.response.data.message, "warning")
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      changeBookMarkBusinessUnit(state, companyId, businessUnitId, taskId){
        let data = this.bookmarkListBusinessUnit
        data.comments = !this.bookmarkListBusinessUnit.comments
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setBusinessUnit?companyId=${companyId}&businessUnitId=${businessUnitId}`, data)
          .then(response => {
            if (this.bookmarkListBusinessUnit.comments) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
          });
      },
      closeModal(){
        this.form.notifyBusinessUnitTeam = true
        this.form.notifyClients = false
        this.form.notifyVendors = false
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
    .add-comment-btn{
        // margin-bottom:15px;
    }
    .box-card{
        margin: 10px 0;
    }
    .card__status{
        display:flex;
        align-items: center;
    }
    .photo-group{
        overflow:hidden;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 20px;
        background: url('~@/assets/img/user-default.jpg');
        background-size: cover;
        img{
            width:100%;
            height:100%;
        }
    }
    .sweet-modal-overlay{
        z-index:1000;
    }
    .flex-twocolumn{
        display:flex;
        .el-form-item__content{
            margin:0 12px;
            font-size:13px;
            &:first-child {
                margin-left: 0px;
            }
        }
    }
    /deep/ ul.el-timeline {
      padding-inline-start: 0px;
    }

    .text {
        position: relative;
        font-size: 14px;
    }

    .notifications {
        position: absolute;
        top: 0; /* Положение от нижнего края */
        right: 0;
        &_box {
            display: flex;
            justify-content: flex-end;
        }
        &_clients{
            margin-right: 10px;
        }
        &_vendors{

        }
    }
    .hovered-node{
        -webkit-box-shadow: 0 0 26px 5px #409EFF;
        box-shadow: 0 0 10px 5px #409EFF;
    }
</style>
